<script>

    import { toast } from 'bulma-toast'
    import { ticketsStore, modalStore, notifyStore} from '../stores'

    import TicketsService from '../$services/tickets.service'
    import DateMethod from '../$methods/date.method'
    import TranslateMethods from '../$methods/translate.methods.js'

    import Search from '../$components/input.search.svelte'
    import Pagination from '../$components/pagination.svelte'
    import Select from '../$components/select.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    $: if ($notifyStore === 'tickets_updated') {
        getTickets()
        notifyStore.set(null)
    }

    let query = {
        admin: true,
        find: null,
        page: 0
    }
    let metadata = {}
    let loading = false

    getTickets()

    async function getTickets() {

        loading = true
        const resp = await TicketsService.getTickets(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        ticketsStore.set(resp.data.userTickets)
        metadata = resp.data.metadata
    }

    function sort(key) {
        query[key] = query[key] === -1 ? 1 : -1
        getTickets()
    }

</script>

<Table items={$ticketsStore.length} total={metadata.total} {loading}>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={query.find} on:enter={getTickets} />
            </div>
            <div class="column is-narrow">
                <Select bind:value={query.status} on:change={getTickets}
                    text="Estatus"
                    options={[
                        {value: 'revisión', text: 'Revisión'},
                        {value: 'seguimiento', text: 'Seguimiento'},
                        {value: 'finalizado', text: 'Finalizado'},
                        {value: 'resuelto', text: 'Resuelto'}
                    ]}
                />
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getTickets } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Estatus</th>
            <th>Usuario</th>
            <th>Guía</th>
            <th class="has-text-right">
                <span class="icon-text is-align-items-center">
                    <span>Fecha</span>
                    <button
                        type="button"
                        class="button is-small is-text p-1 icon"
                        aria-label="Ordenar por fecha"
                        on:click={() => sort('created')}>
                        <span class="icon"><i class="fas fa-sort" aria-hidden="true"></i></span>
                    </button>
                </span>
            </th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $ticketsStore as ticket, index}
            <tr>
                <td>{(metadata.items * query.page) + (index + 1)}</td>
                <td>{TranslateMethods.get(ticket.status)}</td>
                <td>
                    <div>
                        <div>{ticket.user.name}</div>
                        {#if ticket.user.email}
                            <div>{ticket.user.email}</div>
                        {/if}
                    </div>
                </td>
                <td>{ticket.shipment.guide}</td>
                <td class="has-text-right">{DateMethod.dateTimeLarge(ticket.created)}</td>
                <td>
                    <Button on:click={() => modalStore.open('ticket', 'modal', ticket)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
